//
//
//

const NODETYPE_NUMBER = 1;
const NODETYPE_DATE = 2;
const NODETYPE_IDENT = 3;
const NODETYPE_FUNCTION = 4;
const NODETYPE_BINARY = 5;

const NODETYPE_MODRULE = 10;


const OP_AND = 1;
const OP_OR = 2;
const OP_EQ = 3;
const OP_NE = 4;
const OP_LT = 5;
const OP_LE = 6;
const OP_GT = 7;
const OP_GE = 8;
const OP_ADD = 9;
const OP_SUB = 10;
const OP_MUL = 11;
const OP_DIV = 12;

const MODTYPE_INCREASE = 1;
const MODTYPE_DECREASE = 2;
const MODTYPE_SET = 3;



module.exports.NODETYPE_NUMBER = NODETYPE_NUMBER;
module.exports.NODETYPE_DATE = NODETYPE_DATE;
module.exports.NODETYPE_IDENT = NODETYPE_IDENT;
module.exports.NODETYPE_FUNCTION = NODETYPE_FUNCTION;
module.exports.NODETYPE_BINARY = NODETYPE_BINARY;

module.exports.NODETYPE_MODRULE = NODETYPE_MODRULE;



module.exports.OP_AND = OP_AND;
module.exports.OP_OR = OP_OR;
module.exports.OP_EQ = OP_EQ;
module.exports.OP_NE = OP_NE;
module.exports.OP_LT = OP_LT;
module.exports.OP_LE = OP_LE;
module.exports.OP_GT = OP_GT;
module.exports.OP_GE = OP_GE;
module.exports.OP_ADD = OP_ADD;
module.exports.OP_SUB = OP_SUB;
module.exports.OP_MUL = OP_MUL;
module.exports.OP_DIV = OP_DIV;

module.exports.MODTYPE_INCREASE = MODTYPE_INCREASE;
module.exports.MODTYPE_DECREASE = MODTYPE_DECREASE;
module.exports.MODTYPE_SET = MODTYPE_SET;

//---------------------------------------------------------------------------------------------

class ASTNode {
  constructor(type) {
    this.nodeType = type;
  }
}



class ASTExpression extends ASTNode {
  constructor(type) {
    super(type);
  }
}



class ASTDate extends ASTExpression {
  constructor(val) {
    super(NODETYPE_DATE);

    this.dateVal = val;
  }

}


class ASTNumber extends ASTExpression {
  constructor(val) {
    super(NODETYPE_NUMBER);

    this.numVal = val;
  }

}



class ASTIdentifier extends ASTExpression {
  constructor(val) {
    super(NODETYPE_IDENT);

    this.ident = val;
  }

}


class ASTFunction extends ASTExpression {
  constructor(name) {
    super(NODETYPE_FUNCTION);

    this.funcName = name;
    this.params = [];
  }
  
}


class ASTBinary extends ASTExpression {
  constructor(type, left, right) {
    super(NODETYPE_BINARY);

    this.type = type;
    this.left = left;
    this.right = right;
  }
}

//---------------------------------------------------------------------------

class ASTRule extends ASTNode {
  constructor(type) {
    super(type);

    this.condExpr = null;
  }
}



class ASTModificationRule extends ASTRule {
  constructor(type) {
    super(NODETYPE_MODRULE);

    this.type = type;
    this.target = "";
    this.expr = null;
  }

}


module.exports.createASTDate = function(val) {
  return new ASTDate(val);
}

module.exports.createASTNumber = function(val) {
  return new ASTNumber(val);
}

module.exports.createASTIdentifier = function(val) {
  return new ASTIdentifier(val);
}

module.exports.createASTFunction = function(name) {
  return new ASTFunction(name);
}

module.exports.createASTBinary = function(type, left, right) {
  return new ASTBinary(type, left, right);
}


module.exports.createASTModRule = function(type) {
  return new ASTModificationRule(type);
}
